"use client"

import styled from "@emotion/styled"
import Script from "next/script"
import Footer from "./Footer"
import SidebarForm from "./Form"
import HeroBanner from "./Hero"
import LowerContent from "./LowerContent"
import LowerGallery from "./LowerGallery"

const PageContainer = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  direction: ltr;
`
type Props = {
  companyId?: number
}
export default function HomeUpgrades({ companyId }: Props) {
  return (
    <>
      <Script
        id="load-gtm"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-KFXDP9TP');`,
        }}
      />
      {/* Google Tag Manager (noscript) */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-KFXDP9TP"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        />
      </noscript>
      {/* End Google Tag Manager (noscript) */}
      {/* <PageContainerDesktop>
        <Sidebar />
        <MainContent />
      </PageContainerDesktop> */}
      <PageContainer>
        <HeroBanner />
        <SidebarForm companyId={companyId} />
        <LowerGallery />
        <LowerContent />
        <Footer />
      </PageContainer>
    </>
  )
}
